<script>
  import { addHttpIfNot, customInputEvent, validURL } from '../../components/Helper';

  import Select from 'svelte-select';
  import FormInput from '../FormControls/FormInput.svelte';
  import FormTextarea from '../FormControls/FormTextarea.svelte';

  export let form;
  export let errors;
  export let handleChange;
  export let codeEthics;
  export let selectUnitsInfo;
  export let selectedCodeEthics;
  export let legacyCompanyType;
</script>

<div class="p-3 h-100 font-size-12">
  <div class="profile-content mx-auto">
    <div class="block-title mb-4">
      <h3 class="mt-0 title"><span>Other Information</span></h3>
    </div>
  </div>
  <div class="profile-content mx-auto h-100">
    {#if !selectUnitsInfo.outsourcedCfo}
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mb-3 select-block">
            <label
              for=""
              class="form-label">Code of Ethics Software</label
            >
            <Select
              bind:selectedValue={selectedCodeEthics}
              showChevron={true}
              isClearable={true}
              items={codeEthics}
              getSelectionLabel={(option) => {
                return option.name;
              }}
              on:select={(ev) => {
                $form.unitCodeEthicsId = ev.detail.id;
                if ($form.unitCodeEthicsId != '') {
                  $form.ethicsOtherName = '';
                }
              }}
              on:clear={(ev) => {
                $form.unitCodeEthicsId = undefined;
                $form.ethicsOtherName = '';
              }}
              optionIdentifier="id"
              getOptionLabel={(option) => {
                return option.name;
              }}
              placeholder="Code of Ethics Software"
            />
          </div>
        </div>
      </div>
    {/if}
    {#if $form.unitCodeEthicsId != undefined && $form.unitCodeEthicsId == ''}
      <div class="row">
        <div class="col-md-12">
          <FormInput
            name="ethicsOtherName"
            label="Other"
            placeholder="Enter Other"
            error={$errors.ethicsOtherName}
            bind:value={$form.ethicsOtherName}
            handleChange={handleChange}
          />
        </div>
      </div>
    {/if}
    <div class="row">
      <div class="col-md-12">
        <div class="form-group mb-3">
          <FormTextarea
            label="Other Key Details"
            name="notes"
            placeholder="Enter Notes"
            bind:value={$form.notes}
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <FormInput
          name="assetsManagement"
          label="Assets Under Management"
          placeholder="Enter Assets Under Management"
          error={$errors.assetsManagement}
          bind:value={$form.assetsManagement}
          handleChange={handleChange}
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <FormInput
          name="employeesNo"
          label="Number of Employees"
          placeholder="Enter Number of Employees"
          error={$errors.employeesNo}
          bind:value={$form.employeesNo}
          handleChange={handleChange}
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div
          class="form-group mb-2 mt-3 select-block position-relative {$errors.legacyCompanyType
            ? 'error'
            : ''}"
        >
          <div class="row align-items-center">
            <div class="col-md-3">
              <label
                for=""
                class="text-nowrap form-label mb-0"
              >
                Legacy Company:
              </label>
            </div>
            {#each legacyCompanyType as legacyCompany, i}
              <div class="col-md-3 position-relative">
                <div class="row align-items-center justify-content-start">
                  <div class="form-label mb-0 position-relative">
                    <div class="radio c-radio {$errors.legacyCompanyType ? 'error' : ''}">
                      <label class="text-nowrap">
                        <input
                          type="radio"
                          name="legacyCompany"
                          value={legacyCompany.id}
                          bind:group={$form.legacyCompanyType}
                          on:change={(event) => {
                            $form.legacyCompanyType = legacyCompany.id;
                            // resetRecurringData();
                            handleChange(
                              customInputEvent('legacyCompanyType', $form.legacyCompanyType),
                            );
                          }}
                        />
                        <span class="check-img" />
                        {legacyCompany.name}
                      </label>
                      {#if legacyCompany.id == $form.legacyCompanyType}
                        <button
                          on:click={(event) => {
                            $form.legacyCompanyType = '';
                          }}
                          class="btn btn-link position-absolute"
                          style="top: -1px;padding: 0px;"
                          ><span
                            class="color-white font-size-12 font-weight-400"
                            style="
						width: 70px;
						border: 0;
					">De-select</span
                          ></button
                        >
                      {/if}
                    </div>
                  </div>
                </div>
              </div>
            {/each}
          </div>
          {#if $errors.legacyCompanyType}
            <label
              for=""
              class="formError">{$errors.legacyCompanyType}</label
            >
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>
